import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import PdfCanvasViewer from '@/components/bateaux/PdfCanvasViewer';
import { useTranslation } from 'react-i18next';

interface DocumentPreviewDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  fileName?: string;
  mimeType?: string;
  url?: string | null;
  loading?: boolean;
}

const isPdf = (mimeType?: string) => !!mimeType && mimeType.toLowerCase().includes('pdf');

export default function DocumentPreviewDialog({
  open,
  onClose,
  title,
  description,
  fileName,
  mimeType,
  url,
  loading,
}: DocumentPreviewDialogProps) {
  const { t } = useTranslation('boats');
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-5xl">
        <DialogHeader>
          <DialogTitle className="truncate">{title}</DialogTitle>
          <DialogDescription className="truncate">
            {description || fileName || t('documentPreview.defaultDescription')}
          </DialogDescription>
        </DialogHeader>

        <div className="rounded-lg border bg-background overflow-hidden">
          {loading ? (
            <div className="h-[70vh] flex items-center justify-center text-sm text-muted-foreground">
              {t('documentPreview.loading')}
            </div>
          ) : url ? (
            isPdf(mimeType) ? (
              <PdfCanvasViewer url={url} />
            ) : (
              <div className="h-[70vh] flex items-center justify-center bg-muted/20">
                <img
                  src={url}
                  alt={fileName || title}
                  className="max-h-[70vh] max-w-full object-contain"
                  loading="lazy"
                />
              </div>
            )
          ) : (
            <div className="h-[70vh] flex items-center justify-center text-sm text-muted-foreground">
              {t('documentPreview.unavailable')}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
